import { render, staticRenderFns } from "./AdminCockpit.vue?vue&type=template&id=0b125c56&scoped=true&"
import script from "./AdminCockpit.vue?vue&type=script&lang=ts&"
export * from "./AdminCockpit.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCockpit.vue?vue&type=style&index=0&id=0b125c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b125c56",
  null
  
)

export default component.exports